import { render } from "./ChartSandbox.vue?vue&type=template&id=df56a452"
import script from "./ChartSandbox.vue?vue&type=script&lang=js"
export * from "./ChartSandbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__